module.exports = __webpack_public_path__ + "static/media/AICDMB22_single.05a64e99.svg";